import React, { useState } from 'react';
import { GetFromLocalStorage, IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../../utilities/CommonMethods';
import ResourcesSection from './ResourcesSection/ResourcesSection';
import Button from '../../UI/Button/Button';

import classes from './SessionPlanData.module.css';
import ShowLoader from '../../../hoc/ShowMiniLoader/ShowMiniLoader';
import EditResourcesPopup from '../../Popups/EditResourcesPopup/EditResourcesPopup';
import MarkdownInputField from '../../MarkdownInputField/MarkdownInputField';



const SessionPlanData = (props) => {
    // console.log('Live Session Props', props.forInstructor, props.topicData.liveSessionList)
    var liveSessionId = !IsObjectEmpty(props.topicData.liveSessionList[0]) && !IsStringEmpty(props.topicData.liveSessionList[0].liveSessionId) ? props.topicData.liveSessionList[0].liveSessionId : null;
    const [openEditResourcesPopup, setOpenEditResourcesPopup] = useState(false);
    const isStudyMaterialModule = String(props?.topicData?.moduleName || '').toLowerCase().includes('study material');
    const OnCloseModal = () => {
        setOpenEditResourcesPopup(false);
    }

    const startedBy = GetFromLocalStorage("username");
    // console.log(props.topicData.liveSessionList);

    const renderLocalTime = (scheduledDate, scheduledTime) => {
        try {
            // scheduledDate sample: "12 September 2025, Friday"
            const dateText = String(scheduledDate).split(',')[0]; // "12 September 2025"
            const parts = dateText.split(' ');
            const day = parseInt(parts[0], 10);
            const monthName = parts[1];
            const year = parseInt(parts[2], 10);
            const monthIndex = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
                .findIndex(m => m.toLowerCase().startsWith(monthName.toLowerCase())) + 1; // 1-based for ISO

            const tm = String(scheduledTime).trim().toLowerCase();
            const m = tm.match(/(\d{1,2}):(\d{2})\s*(am|pm)/);
            if (!m) return '';
            let h = parseInt(m[1], 10), min = parseInt(m[2], 10); const mer = m[3];
            if (mer === 'pm' && h < 12) h += 12; if (mer === 'am' && h === 12) h = 0;

            // Build ISO with IST offset (+05:30) and let Date convert to local
            const pad = (n) => String(n).padStart(2, '0');
            const isoIST = `${year}-${pad(monthIndex)}-${pad(day)}T${pad(h)}:${pad(min)}:00+05:30`;
            const local = new Date(isoIST);
            const localDate = local.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
            const localTime = local.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
            return `${localDate} | ${localTime} (${tz})`;
        } catch (e) {
            return '';
        }
    }


    return (
        <>
            {
                props.forInstructor && !IsObjectEmpty(props.topicData)
                    ? <div className={classes.ButtonContainer}>
                        <Button
                            label="EDIT TOPIC"
                            margin="0"
                            padding="1em 0 1em 1em"
                            styleclass="TextOnlyButtonBlue"
                            clicked={props.editTopicClicked} />

                    </div>
                    : null
            }
            {/* --------------------------- LIVE Session Section --------------------------- */}
            {!IsListEmpty(props.topicData.liveSessionList) && !isStudyMaterialModule
                ?
                (props.forInstructor === true || props.forProgramManager === true)
                    ? // --------------------------- For Instructor ---------------------------
                    props.topicData.liveSessionList.map((liveSession, index) => {
                        const localLabel = renderLocalTime(liveSession.scheduledDate, liveSession.scheduledTime);
                        return (
                            <div key={liveSession.liveSessionId} >
                                <div className={classes.LiveSessionDiv}>
                                    <div className={classes.SubHeading}>Live Session
                                        <div className={classes.EditLiveSession}>
                                            {props.forProgramManager === true ? <Button
                                                label="EDIT LIVE SESSION"
                                                clicked={props.editLiveSessionClick}
                                                styleclass="TextOnlyButtonBlue"
                                                padding="0" /> : null
                                            }
                                            {
                                                props.showEditLiveSessionDropDown ?
                                                    <div className={classes.MenuItemList}>
                                                        {props.forProgramManager === true ?
                                                            <div className={classes.MenuItem}>
                                                                <Button
                                                                    label="COPY LIVE SESSION DETAILS"
                                                                    clicked={props.copyLiveSessionDetailClicked}
                                                                    padding="0"
                                                                    styleclass="TextOnlyCommentButtonDark" />
                                                            </div> : null
                                                        }
                                                        {
                                                            startedBy === 'admin' || startedBy === 'program-manager'
                                                                ? <div className={classes.MenuItem}>
                                                                    <Button
                                                                        label="EDIT LIVE SESSION DETAILS"
                                                                        padding="0"
                                                                        clicked={props.editLiveSessionDetailClicked}
                                                                        styleclass="TextOnlyCommentButtonDark" />
                                                                </div> : null
                                                        }
                                                        <div className={classes.MenuItem}>
                                                            <Button
                                                                label="GET JOINING LINK"
                                                                padding="0"
                                                                clicked={props.getJoinLink}
                                                                styleclass="TextOnlyCommentButtonDark" />

                                                        </div>

                                                    </div>
                                                    : null
                                            }
                                        </div>
                                    </div>

                                    <p className={classes.LiveSessionText}>
                                        {
                                            !liveSession.sessionEnded && !props.liveSessionEndedManually
                                                ? `Session scheduled on ${liveSession.scheduledDate} at ${liveSession.scheduledTime}`
                                                : 'This session has ended.'

                                        }
                                        {(!liveSession.sessionEnded && !props.liveSessionEndedManually && localLabel)
                                            ? <span className={classes.LocalTimeLine}>
                                                <br /> {localLabel}</span>
                                            : null}

                                        <span className={classes.EnableButton}>
                                            {(!liveSession.sessionEnded && !props.liveSessionEndedManually && props.showEnableButton) ? <Button

                                                label="ENABLE BUTTON"
                                                margin="0"
                                                padding="1em 0 1em 1em"
                                                styleclass="TextOnlyButtonBlue"
                                                clicked={() => props.onEnableLiveSessionButtonClicked(index)} /> : ''}
                                        </span>

                                    </p>


                                    {
                                        props.showLiveSessionLoader
                                            ? <div className={classes.MiniLoaderContainer}>
                                                <ShowLoader isLoading={true} transparentBg={true} />
                                            </div>
                                            : !liveSession.sessionEnded && !props.liveSessionEndedManually
                                                ? <>
                                                    <Button
                                                        label={!IsStringEmpty(liveSession.startURL) ? 'JOIN LIVE SESSION' : 'START LIVE SESSION'}
                                                        padding="1em 2em"
                                                        margin="0.5em 0em 2em 0em"
                                                        fontSize="13px"
                                                        disabled={!liveSession.enableButton}
                                                        clicked={liveSession.enableButton && !props.showLiveSessionLoader
                                                            ? () => props.startLiveSession(liveSession.liveSessionId, liveSession.startURL, startedBy)
                                                            : null} />


                                                    {
                                                        liveSession.enableButton && !props.showLiveSessionLoader
                                                            ? <Button
                                                                label={'END LIVE SESSION'}
                                                                padding="0.9em 2em"
                                                                styleclass='GoToCourseButton'
                                                                margin="0.5em 0em 2em 1.5em"
                                                                fontSize="13px"
                                                                disabled={!liveSession.enableButton}
                                                                clicked={liveSession.enableButton && !props.showLiveSessionLoader
                                                                    ? () => props.endLiveSession(liveSession.liveSessionId)
                                                                    : null} />
                                                            : null
                                                    }

                                                </>
                                                : null

                                    }
                                </div>
                            </div>
                        );
                    })
                    : // --------------------------- For Learner ---------------------------
                    props.topicData.liveSessionList.map((liveSession, index) => {
                        const localLabel = renderLocalTime(liveSession.scheduledDate, liveSession.scheduledTime);
                        return (
                            <div key={index} >
                                <div className={classes.LiveSessionDiv}>
                                    <h4 className={classes.SubHeading}>Session Plan</h4>
                                    {/* <div className={classes.FlexDisplay}> */}
                                    <p className={classes.LiveSessionText}>
                                        {
                                            !liveSession.sessionEnded
                                                ? liveSession.started || props.enableLiveSessionButton
                                                    ? 'LIVE session has started. Click on the button below to join the session.'
                                                    : liveSession.enableButton
                                                        ? 'LIVE session is about to start. Please stay tuned.'
                                                        : `Session scheduled on ${liveSession.scheduledDate} at ${liveSession.scheduledTime}`
                                                : <>This LIVE session has ended. You can watch the session recording in the <span className={classes.TextLinkNormal}
                                                    onClick={() => props.onTabClick(3)}>Session Recording</span> Tab.</>
                                        }
                                        {(!liveSession.sessionEnded && localLabel)
                                            ? <span className={classes.LocalTimeLine}><br /> -- {localLabel}</span>
                                            : null}
                                    </p>
                                    <div key={index}>
                                        {!liveSession.sessionEnded
                                            ? <Button
                                                label='JOIN LIVE SESSION'
                                                fontSize="0.75em"
                                                clicked={!liveSession.started && !props.enableLiveSessionButton ? null : () => props.showLiveSessionPopup(liveSession.liveSessionId)}
                                                disabled={!liveSession.started && !props.enableLiveSessionButton}
                                                styleclass=""
                                                margin="0em 0px 0px 0px"
                                                padding="8px 24px"
                                            /> : null}
                                    </div>
                                    {/* </div> */}
                                </div>
                            </div>
                        );
                    })

                : null
            }
            {
                openEditResourcesPopup ?
                    <EditResourcesPopup
                        liveSessionId={liveSessionId}
                        onClose={OnCloseModal}
                        topicId={props.topicData.id}
                        topicData={props.topicData}
                        getTopicDetails={props.getTopicDetails}
                        onSuccessDialogShow={props.onSuccessDialogShow}
                        onFailureDialogShow={props.onFailureDialogShow}
                        redirectToUnauthorized={props.redirectToUnauthorized}
                        showSessionExpiredDialog={props.showSessionExpiredDialog}
                        redirectToNotFound={props.redirectToNotFound}
                        redirectToServerError={props.redirectToServerError}
                        onUploadSuccessful={props.onUploadSuccessful} />
                    : null
            }

            {/* --------------------------- Session PLAN Section --------------------------- */}
            {/* <p className={classes.SubHeading}>Session Plan</p> */}
            {
                props.forInstructor && !IsObjectEmpty(props.topicData)
                    // ? <p className={classes.TextLink} onClick={props.editSessionPlanClicked}>EDIT SESSION PLAN</p>
                    ? <div className={classes.ButtonContainer}>
                        <Button
                            label="EDIT SESSION PLAN"
                            margin="0"
                            padding="1em 0 1em 1em"
                            styleclass="TextOnlyButtonBlue"
                            clicked={props.editSessionPlanClicked} />
                    </div>
                    : null
            }
            <p className={classes.SubTopicHeading}>Sub-Topics</p>
            {
                !IsListEmpty(props.topicData.sessionTopics)
                    ? <ul className={classes.SessionPlanToipcs}>
                        {
                            props.topicData.sessionTopics.map((topic) => {
                                return <li key={topic.name} className={classes.SessionTopic}>{topic.name}</li>
                            })
                        }
                    </ul>
                    : <p className={classes.MessageText}>No Session Topics Added Yet!</p>
            }

            {/* --------------------------- Session Description Section --------------------------- */}
            <p className={classes.SubTopicHeading}>Session Details</p>
            <div
                className={classes.TopicDescription}>
                {/* dangerouslySetInnerHTML={{ __html: props.topicData.description }}> */}
                <MarkdownInputField value={props.topicData.description} onChange={() => console.log('something')} notEditable={true} showImageOption={props.showImageOption === true} />
            </div>


            {/* --------------------------- Session RESOURCES Section --------------------------- */}
            <span className={classes.LinkContainer}>
                {/* <span className={classes.SubHeading}>Resources</span> */}
                {props.forInstructor || props.forProgramManager ?
                    <div className={classes.ButtonContainer}>
                        <Button
                            label="EDIT RESOURCES"
                            margin="0"
                            padding="1em 0 1em 1em"
                            styleclass="TextOnlyButtonBlue"
                            clicked={() => setOpenEditResourcesPopup(!openEditResourcesPopup)} />
                    </div>
                    : null}
            </span>
            {
                props.forInstructor || props.forProgramManager
                    ?
                    !IsObjectEmpty(props.topicData.resources)
                        ? <ResourcesSection
                            topicResources={props.topicData.resources}
                            title={props.topicData.title}
                            topicId={props.topicData.id}
                            moduleName={props.topicData.moduleName}
                            batchCode={props.batchCode}
                            onSuccessDialogShow={props.onSuccessDialogShow} />
                        : <p className={classes.MessageText}>No Resources Added Yet!</p>
                    : null
            }
        </>
    );
}

export default SessionPlanData;